import { Alert, FormControlLabel, Stack, Switch, Typography } from "@mui/material";

interface Props {
  useBcReportGenerationViaSession: boolean;
  isUpdating: boolean;
  lastConfirmation?: string;
  updateError?: string;
  onChangeUseBcReportGenerationViaSession: (enabled: boolean) => void;
}

const ClientProfileExcelAddinSection = ({
  useBcReportGenerationViaSession,
  isUpdating,
  lastConfirmation,
  updateError,
  onChangeUseBcReportGenerationViaSession,
}: Props) => {
  return (
    <Stack spacing={1}>
      <Typography variant="h6">Excel Add-in</Typography>
      <Typography variant="caption" color="textSecondary">
        Inherited by all managed companies in this organization.
      </Typography>
      {updateError && (
        <Alert severity="error" variant="outlined">
          {updateError}
        </Alert>
      )}
      {lastConfirmation && (
        <Alert severity="success" variant="outlined">
          {lastConfirmation}
        </Alert>
      )}
      <FormControlLabel
        control={
          <Switch
            checked={useBcReportGenerationViaSession}
            disabled={isUpdating}
            onChange={(_, checked) => onChangeUseBcReportGenerationViaSession(checked)}
          />
        }
        label="Use BC report generation via session"
      />
    </Stack>
  );
};

export default ClientProfileExcelAddinSection;
